export class HttpError extends Error {
  status: number;
  errorCode?: string;
  errorMessage?: string;
  /** Alias for legacy `err.response?.status` / `err.response?.data` readers. */
  response?: { status: number; data?: unknown };

  constructor(message: string, status: number, errorCode?: string, errorMessage?: string) {
    super(message);
    this.status = status;
    this.errorCode = errorCode;
    this.errorMessage = errorMessage;
  }

  toString() {
    return `HttpError: ${this.message} (status: ${this.status}, code: ${this.errorCode}, message: ${this.errorMessage})`;
  }
}
